import React from "react";

const ClouldUpload = ({color}) => {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 48 48"
      className="size-16"
    >
      <g id="Layer_2" data-name="Layer 2">
        <g id="invisible_box" data-name="invisible box">
          <rect width="48" height="48" fill="none" />
        </g>
        <g id="icons_Q2" data-name="icons Q2">
          <path d="M40.5,21.8a9.1,9.1,0,0,0-3.4-6.5A9.8,9.8,0,0,0,29.6,13,12.2,12.2,0,0,0,19.5,7a11.6,11.6,0,0,0-8.9,4,12.4,12.4,0,0,0-3.2,8.4,11.8,11.8,0,0,0-5.2,8.2A11.5,11.5,0,0,0,5.3,37.8,12.4,12.4,0,0,0,14,41H34.5c7.7,0,11.3-5.1,11.5-9.9A9.9,9.9,0,0,0,40.5,21.8Zm-7.8,6.4a2,2,0,0,1-3.1.2L26,24.8V36a2,2,0,0,1-4,0V24.8l-3.6,3.6a2,2,0,0,1-3.1-.2,2.1,2.1,0,0,1,.4-2.7l6.9-6.9a1.9,1.9,0,0,1,2.8,0l6.9,6.9A2.1,2.1,0,0,1,32.7,28.2Z" fill={color} />
        </g>
      </g>
    </svg>
  );
};

export default ClouldUpload;
